export const routesToSkip: string[] = [
    'login',
    'create-account',
    'create-password',
    'create-user',
    'logout',
];
